import { api } from './client'

export type TeaState = 'fresh' | 'dried'
export type TeaPurchasePaymentStatus = 'unpaid' | 'paid'
export type TeaPurchasePaymentMethod = 'cash' | 'bank_transfer'

export interface TeaPurchase {
    id: string
    code: string
    grower_id: string
    tea_type_id: string
    purchase_date: string
    tea_state: TeaState
    quantity: number
    image_url?: string | null
    note?: string | null
    payment_status: TeaPurchasePaymentStatus
    paid_at?: string | null
    paid_by?: string | null
    paid_amount?: number | null
    payment_method?: TeaPurchasePaymentMethod | null
    payment_proof_url?: string | null
    dry_quantity?: number | null
    processed_at?: string | null
    processed_by?: string | null
    created_by?: string | null
    created_at: string
    updated_at: string
    // hydrated read-side
    grower_name?: string
    tea_type_name?: string
    paid_by_name?: string
    processed_by_name?: string
    created_by_name?: string
}

export interface ListTeaPurchasesParams {
    grower_id?: string
    tea_state?: TeaState
    payment_status?: TeaPurchasePaymentStatus
    processed?: boolean
    has_active_pnk?: boolean
    search?: string
    date_from?: string
    date_to?: string
    page?: number
    per_page?: number
}

export interface CreateTeaPurchaseRequest {
    grower_id: string
    tea_type_id: string
    purchase_date?: string
    tea_state?: TeaState
    quantity: number
    image_url?: string
    note?: string
}

export interface PatchTeaPurchaseRequest {
    grower_id?: string
    tea_type_id?: string
    purchase_date?: string
    tea_state?: TeaState
    quantity?: number
    image_url?: string
    note?: string
}

export interface MarkProcessedRequest {
    dry_quantity: number
    processed_at: string
}

export interface MarkPaidRequest {
    paid_amount: number
    payment_method: TeaPurchasePaymentMethod
    payment_proof_url?: string
}

export const teaPurchaseApi = {
    list: (params?: ListTeaPurchasesParams) =>
        api.get<TeaPurchase[]>('/tea-purchases', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    get: (id: string) => api.get<TeaPurchase>(`/tea-purchases/${id}`),
    create: (data: CreateTeaPurchaseRequest) =>
        api.post<TeaPurchase>('/tea-purchases', data),
    patch: (id: string, data: PatchTeaPurchaseRequest) =>
        api.patch<TeaPurchase>(`/tea-purchases/${id}`, data),
    markPaid: (id: string, data: MarkPaidRequest) =>
        api.post<TeaPurchase>(`/tea-purchases/${id}/mark-paid`, data),
    markProcessed: (id: string, data: MarkProcessedRequest) =>
        api.post<TeaPurchase>(`/tea-purchases/${id}/mark-processed`, data),
}
